import { userLogin, getuserInfo } from "@/api/open";
const state = {
  userId: "",
  userInfo: "",
  roles: [],
  administratorHead:"",
  administratorId:"",
  administratorName:""
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USERID: (state, userId) => {
    state.userId = userId;
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_USER_HEAD:(state, administratorHead)=>{
    state.administratorHead=administratorHead
  },
  SET_USER_NAME:(state, administratorName)=>{
    console.log(administratorName);
    state.administratorName=administratorName
  },
  SET_USER_USERID:(state, administratorId)=>{
    state.administratorId=administratorId
  }
}

const actions = {
  // 存储用户信息
  GetInfo({ commit }, state) {
    console.log(commit, state);
    let userLevel = ''
    let userLevelId = ''
    if (state.jcy2 == null || state.jcy2 == '') {
      userLevelId = 1  //给后台
    } else {
      userLevelId = 2
    }
    if(state.role == 2){
      if (state.role == 2 && state.jcy2 == null || state.role == 2 && state.jcy2 == '') {
        userLevel = '1' //省政治部审核
      } else {
        userLevel = '2' //市区政治部审核 
      }
    }else if(state.role == 3){
      // console.log(userLevel);
      if (state.role == 3 && state.jcy2 == null || state.role == 3 && state.jcy2 == '') { //管理员
        userLevel = '1' //省管理员
      } else {
        userLevel = '2'//市区管理员
      }
    }
    state.userLevel = userLevel
    state.userLevelId = userLevelId
    commit("SET_USERINFO", state);
    commit("SET_ROLES", JSON.parse(state.auth));
  },
  // 前端 登出
  LogOut({ commit }) {
    return new Promise((resolve) => {
      commit("SET_USERINFO", "");
      commit("SET_ROLES", []);
      // removeToken();
      resolve();
    });
  },
  GetUserInfo({commit},state) {
    console.log(state);
    commit('SET_USER_HEAD', state.head_image)
    commit('SET_USER_NAME', state.username)
    commit('SET_USER_USERID', state.id)
    
  }
}

export default {
  state,
  mutations,
  actions
}

